<template>
  <div class="cookie-page py-7">
    <div class="container">
      <h1 class="display-5 fw-bold mb-4">Cookie Policy</h1>

      <div class="content">
        <p class="text-muted mb-4">Ultimo aggiornamento: {{ new Date().toLocaleDateString('it-IT') }}</p>

        <section class="mb-5">
          <h2 class="h4 mb-3">1. Definizione di Cookie</h2>
          <p>I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva.</p>
        </section>

        <section class="mb-5">
          <h2 class="h4 mb-3">2. Tipologie di Cookie Utilizzati</h2>
          <ul class="list-unstyled">
            <li class="mb-4">
              <strong>2.1 Cookie tecnici (necessari)</strong>
              <p>Strettamente necessari per il funzionamento del sito. Non richiedono consenso.</p>
              <ul>
                <li>Cookie di sessione</li>
                <li>Cookie di navigazione</li>
              </ul>
            </li>
            <li class="mb-4">
              <strong>2.2 Cookie analitici (statistici)</strong>
              <p>Utilizzati in forma anonima per analisi statistiche.</p>
              <ul>
                <li>Google Analytics (anonimizzato)</li>
                <li>Durata: 12 mesi</li>
              </ul>
            </li>
            <li class="mb-4">
              <strong>2.3 Cookie di profilazione</strong>
              <p>Non utilizziamo cookie di profilazione.</p>
            </li>
          </ul>
        </section>

        <section class="mb-5">
          <h2 class="h4 mb-3">3. Base Giuridica</h2>
          <ul>
            <li>Cookie tecnici: legittimo interesse (Art. 6.1.f GDPR)</li>
            <li>Cookie analitici: consenso (Art. 6.1.a GDPR)</li>
          </ul>
        </section>

        <section class="mb-5">
          <h2 class="h4 mb-3">4. Gestione dei Cookie</h2>
          <p>È possibile gestire le preferenze sui cookie attraverso:</p>
          <ul class="list-unstyled">
            <li class="mb-3">
              <strong>Banner dei cookie:</strong>
              <p>Al primo accesso al sito, tramite il banner dedicato</p>
            </li>
            <li class="mb-3">
              <strong>Impostazioni del browser:</strong>
              <div class="browser-settings mt-3">
                <ul class="list-unstyled">
                  <li class="mb-2">
                    <a href="https://support.google.com/chrome/answer/95647?hl=it" target="_blank" rel="noopener noreferrer">
                      <i class="bi bi-chevron-right"></i> Chrome
                    </a>
                  </li>
                  <li class="mb-2">
                    <a href="https://support.mozilla.org/it/kb/protezione-antitracciamento-avanzata-firefox-desktop" target="_blank" rel="noopener noreferrer">
                      <i class="bi bi-chevron-right"></i> Firefox
                    </a>
                  </li>
                  <li class="mb-2">
                    <a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">
                      <i class="bi bi-chevron-right"></i> Safari
                    </a>
                  </li>
                  <li class="mb-2">
                    <a href="https://support.microsoft.com/it-it/microsoft-edge/eliminare-i-cookie-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">
                      <i class="bi bi-chevron-right"></i> Edge
                    </a>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </section>

        <section class="mb-5">
          <h2 class="h4 mb-3">5. Aggiornamenti</h2>
          <p>La presente Cookie Policy può essere soggetta ad aggiornamenti. Gli utenti sono invitati a consultare periodicamente questa pagina.</p>
        </section>
      </div>
    </div>
  </div>
</template>

<style scoped>
.cookie-page {
  background: rgba(142, 202, 230, 0.1);
}

.content {
  max-width: 800px;
  margin: 0 auto;
}

h2 {
  color: #219ebc;
}

p {
  color: #666;
  line-height: 1.6;
}

strong {
  color: #023047;
}

.browser-settings a {
  color: #219ebc;
  text-decoration: none;
  transition: all 0.3s ease;
}

.browser-settings a:hover {
  color: #023047;
  padding-left: 5px;
}

.bi-chevron-right {
  font-size: 0.8rem;
}
</style>
